import { ITheme } from 'src/app/shared/interfaces/ITheme';

export const lightTheme: ITheme = {
  bgColorPrimary: '#ffffff',
  textColor: '#000028',
  petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
  highlightColor: '#009999',
  actionColor: '#007993',
  actionHoverColor: '#005159',
  actionDisabledColor: '#9999A9',
  actionDisabledBgColor: '#E5E5E9',
  bgColorSecondary: '#F3F3F0',
  bgHoverColor: '#E8E8E3',
  chipBackgroundColor: '#C5FFEF',
  chipBorderColor: '#C5FFEF',
  chipBgHover: '#62EEC7',
  chipBGHoverBorder: '#62EEC7',
  chipTextColor: '#000028',
  textColorSecondary: '#66667e',
  textColorWarning: '#EB780A',
  warningColor: '#B81E31',
  inputBgColor: '#ebf7f8',
  inputBorderColor: '#4C4C68',
  inputActiveBgColor: '#d1fff2',
  inputActiveBorderColor: '#005159',
  selectOptionHoverColor: '#62EEC7',
  radioButtonBorderColor: '#4C4C68',
  radioButtonBGColor: 'transparent',
  slideThumbColor: '#ffffff',
  slideBarColor: '#7D8099',
  slideThumbActiveColor: '#196269',
  slideBarActiveColor: '#005159',
  slideBarDisabledColor: '#EBEBEE',
  slideThumbDisabledColor: '#CCCCD4',
  tabBorder: '#CCCCD4',
  tabLabelActiveColor: '#005159',
  tooltipBG: '#000028',
  tooltipSuccess: '#01893a',
  tooltipWarning: '#FFD732',
  tooltipError: '#D72339',
  heroBtnBgHover: '#62EEC7',
  inputErrorBG: '#FCCCD7',
  checkboxSelectedCheck: '#ffffff',
  checkboxSelectedBG: '#005159',
  checkboxDisabledBorder: '#7D8099',
  expansionPanelBorder: '#000028',
  expansionPanelHoverBG: '#D1FFF2',
  expansionPanelHoverBorder: '#005159',
  primaryBtnBG: '#007993',
  primaryBtnBGHover: '#005159',
  primaryBtnText: '#ffffff',
  primaryBtnTextHover: '#ffffff',
  secondaryBtnBG: '#ffffff',
  secondaryBtnBGHover: '#D1FFF2',
  secondaryBtnText: '#007993',
  secondaryBtnTextHover: '#005159',
  tetriaryBtnBG: '#ffffff',
  tetriaryBtnBGHover: '#D1FFF2',
  tetriaryBtnText: '#007993',
  tetriaryBtnTextHover: '#005159',
  snackbarBG: '#ffffff',
  searchInputBG: '#ffffff',
  tableHighlightBG: '#EBEBEE',
  tileBGColor: '#F3F3F0',
  tileTextColor: '#000028',
  tileBGHoverColor: '#DFDFD9',
  tileTextHoverColor: '#000028',
  tableHeadBG: '#F5F5F5',
  tableBG: '000000',
  tableTextColor: '#000028',
  tableBorderColor: '#C5C5B8',
  tableRowSelectedColor: '#E6F8FB',
  paginatorBG: '#FFFFFF',
  paginatorTextColor: '#000000',
  loginPageInfoBG: '#FFFFFF',
  focusVisibleBorderColor: '#E9C32A',
  userSettingsAvatar: '#CCCCD4',
  userSettingsAvatarImpersonate: '#D1FFF2',
  userSettingsAvatarImpersonateActive: '#62EEC7',
  userSettingsActive: '#E8E8E3',
  userSettingsImpersonate: '#EBF7F8',
  userSettingsImpersonateActive: '#D1FFF2',
  menuItemDisabled: '#E9E9EE',
  actionHeaderSearchBG: '#FFFFFF',
  pueRedColor: '#D72339',
  pueGreenColor: '#01893A',
  priorityHighColor: '#C75300',
  priorityMediumColor: '#E9C32A',
  datepickerCellColor: '#007993',
  datepickerCellBorderColor: '#000028',
  datepickerCellSelectedColor: '#FFFFFF',
  datepickerCellSelectedBG: '#196269',
  datepickerCellSelectedHover: '#005159',
  datepickerHeaderColor: '#000028',
  employeePickerLabel: ' #4C4C68',
  inputBoxShadow: '#0000281E',
  focusOutline: '#1491EB',
  inputDisabledBg: '#ffffff',
  inputDisabledBorder: '#CCCCD4',
  inputDisabledText: '#4C4C68',
  warningBtnBg: '#D72339',
  warningBtnBgHover: '#B81E31',
  datePickerBG: '#F3F3F0',
  datePickerHeader: '#000028',
  datePickerDateHover: '#E8E8E3',
  datePickerDateSelectedBG: '#196269',
  datePickerDateSelected: '#FFFFFF',
  scrollbar: '#B3B3BE',
  calendarBorderColor: '#C5C5B8',
  calendarBG: '#FFFFFF',
  calendarSecondaryBG: '#EBEBEE',
  calendarSelectedRowBG: '#ebf7f8',
  calendarSelectedRowSecondaryBG: '#dceaeb',
  calendarReadonlyBG: '#F5F5F5',
  timepickerColorScheme: 'light',
};

export const darkTheme: ITheme = {
  bgColorPrimary: '#000028',
  bgColorSecondary: '#23233C',
  bgHoverColor: '#37374D',
  textColor: '#ffffff',
  petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
  highlightColor: '#009999',
  actionColor: '#00CCCC',
  actionHoverColor: '#00FFB9',
  actionDisabledColor: '#737389',
  actionDisabledBgColor: '#333353',
  chipBackgroundColor: '#C5FFEF',
  chipBorderColor: '#62EEC7',
  chipBgHover: '#62EEC7',
  chipTextColor: '#000028',
  chipBGHoverBorder: '#62EEC7',
  textColorSecondary: '#9999A9',
  textColorWarning: '#EB780A',
  warningColor: '#FF7687',
  inputBgColor: '#00183B',
  inputBorderColor: '#B3B3BE',
  inputActiveBgColor: '#001F39',
  inputActiveBorderColor: '#00FFB9',
  selectOptionHoverColor: '#005159',
  radioButtonBorderColor: '#B3B3BE',
  radioButtonBGColor: '#262648',
  slideThumbColor: '#000028',
  slideBarColor: '#9999A9',
  slideThumbActiveColor: '#FFFFFF',
  slideBarActiveColor: '#00E5AA',
  slideBarDisabledColor: '#333353',
  slideThumbDisabledColor: '#737389',
  tabBorder: '#737389',
  tabLabelActiveColor: '#00FFB9',
  tooltipBG: '#F3F3F0',
  tooltipSuccess: '#01D65A',
  tooltipWarning: '#FFD732',
  tooltipError: '#FF2640',
  heroBtnBgHover: '#C5FFEF',
  inputErrorBG: '#331131',
  checkboxSelectedCheck: '#000028',
  checkboxSelectedBG: '#00FFB9',
  checkboxDisabledBorder: '#737389',
  expansionPanelBorder: '#FFFFFF',
  expansionPanelHoverBG: '#001F39',
  expansionPanelHoverBorder: '#00FFB9',
  primaryBtnBG: '#00CCCC',
  primaryBtnBGHover: '#00FFB9',
  primaryBtnText: '#000028',
  primaryBtnTextHover: '#000028',
  secondaryBtnBG: '#000028',
  secondaryBtnBGHover: '#001F39',
  secondaryBtnText: '#00CCCC',
  secondaryBtnTextHover: '#00FFB9',
  tetriaryBtnBG: '#000028',
  tetriaryBtnBGHover: '#001F39',
  tetriaryBtnText: '#00CCCC',
  tetriaryBtnTextHover: '#00FFB9',
  snackbarBG: '#23233C',
  searchInputBG: '#00183B',
  tableHighlightBG: '#23233C',
  tileBGColor: '#23233C',
  tileTextColor: '#00CCCC',
  tileBGHoverColor: '#333353',
  tileTextHoverColor: '#00FFB9',
  tableHeadBG: '#23233C',
  tableBG: '#23233C;',
  tableTextColor: '#FFFFFF',
  tableBorderColor: '#7D8099',
  tableRowSelectedColor: '#004666',
  paginatorBG: '#000028',
  paginatorTextColor: '#FFFFFF',
  loginPageInfoBG: '#000028',
  focusVisibleBorderColor: '#FFD732',
  userSettingsAvatar: '#4C4C68',
  userSettingsAvatarImpersonate: '#008F9B',
  userSettingsAvatarImpersonateActive: '#00CCCC',
  userSettingsActive: '#002949',
  userSettingsImpersonate: '#007082',
  userSettingsImpersonateActive: '#008F9B',
  menuItemDisabled: '#737389',
  actionHeaderSearchBG: '#00183B',
  pueRedColor: '#FF2640',
  pueGreenColor: '#01D65A',
  priorityHighColor: '#FF9000',
  priorityMediumColor: '#FFD732',
  datepickerCellColor: '#00CCCC',
  datepickerCellBorderColor: '#FFFFFF',
  datepickerCellSelectedColor: '#000028',
  datepickerCellSelectedBG: '#00FFB9',
  datepickerCellSelectedHover: '#66FFD5',
  datepickerHeaderColor: '#FFFFFF',
  employeePickerLabel: ' #B3B3BE',
  inputBoxShadow: '#0000281E',
  focusOutline: '#1491EB',
  inputDisabledBg: '#000028',
  inputDisabledBorder: '#4C4C68',
  inputDisabledText: '#B3B3BE',
  warningBtnBg: '#D72339',
  warningBtnBgHover: '#FF7687',
  datePickerBG: '#23233C',
  datePickerHeader: '#FFFFFF',
  datePickerDateHover: '#37374D',
  datePickerDateSelected: '#000028',
  datePickerDateSelectedBG: '#00FFB9',
  scrollbar: '#B3B3BE',
  calendarBorderColor: '#7D8099',
  calendarBG: '#000028',
  calendarSecondaryBG: '#333353',
  calendarSelectedRowBG: '#00183B',
  calendarSelectedRowSecondaryBG: '#01132e',
  calendarReadonlyBG: '#23233C',
  timepickerColorScheme: 'dark',
};
